import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=f6ebe7c0&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=f6ebe7c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ebe7c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6ebe7c0')) {
      api.createRecord('f6ebe7c0', component.options)
    } else {
      api.reload('f6ebe7c0', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=f6ebe7c0&scoped=true&", function () {
      api.rerender('f6ebe7c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4txOZF42RsXAR/JS/comp/Voucher.vue"
export default component.exports